import * as actions from './redux/actions';
import * as commonActoins from '../common/redux/actions';
import * as serviceActions from '../Pasajebus/PasajebusServiceList/redux/actions';

import {
  KuposErrorSuccessModal,
  KuposFooter,
  KuposInput,
  KuposModalWithButtons,
  SvgHome,
  TopStrip,
} from '../common';
import React, { Component, useEffect, useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';

import ApiUrls from '../../services/apiUrls';
import { AppData } from '../../services';
import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import NewSearchBox from '../common/NewSearchBox';
import PropTypes from 'prop-types';
import SideMenu from '../common/SideMenu/SideMenu';
import { bindActionCreators } from 'redux';
import common_en from '../../translations/en/common.json';
import common_es from '../../translations/es/common.json';
import { connect } from 'react-redux';
import i18next from 'i18next';

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: localStorage.getItem('selectedLanguage') || 'es', // language to use
  resources: {
    en: {
      common: common_en, // 'common' is our custom namespace
    },
    es: {
      common: common_es,
    },
  },
});

class App extends Component {
  static propTypes = {
    // home,
    pbServiceList: PropTypes.object,
    actions: PropTypes.object.isRequired,
    children: PropTypes.node,
  };

  static defaultProps = {
    children: '',
  };
  constructor(props) {
    super(props);
    this.state = {
      newSearchKey: 1,
    };
    this.checkResetPassword();
    this.checkVerivication();
  }

  checkResetPassword() {
    if (CommonService.getParameterByName('reset_password_token')) {
      this.state.showResetPasswordModal = true;
    }
  }
  checkVerivication() {
    let verification = CommonService.getParameterByName('confirmation_token');
    if (verification) {
      this.props.actions
        .accountConfirmation({ url: ApiUrls.accountConfirmation(verification) })
        .then(
          (res) => {
            if (res.data && res.data.status == 200) {
              this.setState({
                showSuccessModel: true,
                showSuccessStatus: true,
                showSuccessBody: 'Su cuenta ha sido confirmada con éxito',
              });
            } else if (res.data) {
              this.setState({
                showSuccessModel: true,
                showSuccessStatus: false,
                showSuccessBody: res.data.error,
              });
            }
          },
          (err) => {
            console.log(err);
          },
        );
    }
  }

  componentDidMount() {
    this.loadStartupData();
    this.onScroll();
    let loginData = CommonService.getLocal('loginData');
    CommonService.storeLoginDetails(loginData, this.props.actions.setLoginData, true);
    window.gapi.load('client:auth2', () => {
      window.gapi.client
        .init({
          apiKey: 'AIzaSyCLqEKPeNaJ_dtB2tZdsFYuVyhrzhd6kVE',
          clientId: '528940335711-q8aacj5gu4ccitln3h7787ucdqm59qj9.apps.googleusercontent.com',
          plugin_name: 'chat',
          scope: 'profile',
        })
        .then(function () {
          // 3. Initialize and make the API request.
          return window.gapi.client.request({
            path:
              'https://people.googleapis.com/v1/people/me?requestMask.includeField=person.names',
          });
        })
        .then(
          function (response) {
            // console.log(response.result);
          },
          function (reason) {
            console.log('Error: ' + reason);
          },
        );
    });
  }

  onScroll = () => {
    this.topHeader = window.document.querySelector(
      '.nav-section.home-nav-section.common-top-strip',
    );

    if (
      this.props.history.location.pathname.length > 4 &&
      !CommonService.isHome(this.props.history.location.pathname) &&
      this.props.history.location.pathname.indexOf('index.ht') < 0 &&
      this.props.history.location.pathname.indexOf('my-account') < 0 &&
      this.topHeader
    ) {
      this.topStripClass = 'header-box ';
      this.topHeader.className = 'nav-section home-nav-section common-top-strip header-box';
      if (CommonService.isBusOrTrain()) {
        this.setState({
          showSearchBox: true,
        });
      } else {
        this.topStripClass = 'header-box  payments-page-header';
        this.topHeader.className =
          'nav-section home-nav-section common-top-strip header-box payments-page-header';
      }
    } else if (
      this.props.history.location.pathname.indexOf('my-account') >= 0 ||
      this.props.history.location.pathname.length <= 4 ||
      CommonService.isHome(this.props.history.location.pathname) ||
      this.props.history.location.pathname.indexOf('index.ht') > -1
    ) {
      this.topStripClass = '';
      this.topHeader.className = 'nav-section home-nav-section common-top-strip';
      this.setState({
        logoType: 1,
      });
    } else {
      this.topStripClass = 'header-box  payments-page-header';
      this.topHeader.className =
        'nav-section home-nav-section common-top-strip header-box payments-page-header';
    }

    window.addEventListener('scroll', (event) => {
      var scroll = event.currentTarget.scrollY;
      var menu = window.document.querySelector('.home-banner');
      var menuSearch = window.document.querySelector('.common-new-search-box');
      if (menuSearch) {
        if (scroll > 60) {
          menuSearch.className = 'common-new-search-box hide-searchbox';
          this.props.pbServiceList.openNewSearch
            ? this.props.actions.openCloseNewSearch(false)
            : null;
        } else {
          menuSearch.className = 'common-new-search-box';
        }
      }

      if (
        this.props.history.location.pathname.indexOf('booking') > -1 ||
        this.props.history.location.pathname.indexOf('/payment') > -1
      ) {
        let paymentSideBar = document.querySelector('.pb-payment-details-payment-right-side-bar');
        let paymentPageContent = document.querySelector('.pb-service-list-payment-details-page');
        if (paymentSideBar) {
          // OLD CONDITION
          // if (
          //   (paymentPageContent.getBoundingClientRect().top <= this.topHeader.clientHeight + 25 &&
          //     paymentPageContent.getBoundingClientRect().bottom >
          //       paymentSideBar.getBoundingClientRect().bottom + 30) ||
          //   (paymentSideBar.getBoundingClientRect().top > this.topHeader.clientHeight + 25 &&
          //     paymentSideBar.className ==
          //       'pb-payment-details-payment-right-side-bar journey-summary-sidebar absolute-fare-details')
          // )

          if (
            paymentPageContent.getBoundingClientRect().top <= this.topHeader.clientHeight + 25 ||
            (paymentSideBar.getBoundingClientRect().top > this.topHeader.clientHeight + 25 &&
              paymentSideBar.className ==
                'pb-payment-details-payment-right-side-bar journey-summary-sidebar absolute-fare-details')
          ) {
            if (
              paymentSideBar.className !=
              'pb-payment-details-payment-right-side-bar journey-summary-sidebar fixed-fare-details'
            ) {
              paymentSideBar.className =
                'pb-payment-details-payment-right-side-bar journey-summary-sidebar fixed-fare-details';
            }
          }

          // else if (
          //   paymentPageContent.getBoundingClientRect().bottom <=
          //   paymentSideBar.getBoundingClientRect().bottom + 30
          // ) {
          //   if (
          //     paymentSideBar.className !=
          //     'pb-payment-details-payment-right-side-bar journey-summary-sidebar absolute-fare-details'
          //   ) {
          //     paymentSideBar.className =
          //       'pb-payment-details-payment-right-side-bar journey-summary-sidebar absolute-fare-details';
          //   }
          // }
          else {
            if (
              paymentSideBar.className !=
              'pb-payment-details-payment-right-side-bar journey-summary-sidebar'
            ) {
              paymentSideBar.className =
                'pb-payment-details-payment-right-side-bar journey-summary-sidebar';
            }
          }
        }
      } else if (CommonService.isBusOrTrain() || CommonService.isBusOrTrain()) {
        let filterBar = document.querySelector('.pb-service-list-service-filter');
        let servicePageContent = document.querySelector('.services-list-container');
        let header = document.querySelector('.header-details');
        if (filterBar) {
          if (
            (servicePageContent.getBoundingClientRect().top <= header.clientHeight + 25 &&
              +servicePageContent.getBoundingClientRect().bottom.toFixed(0) >
                +filterBar.getBoundingClientRect().bottom.toFixed(0)) ||
            (filterBar.getBoundingClientRect().top > header.clientHeight + 25 &&
              filterBar.className ==
                'pb-service-list-service-filter filter-container absolute-service-filters')
          ) {
            if (
              filterBar.className !=
              'pb-service-list-service-filter filter-container fixed-service-filters'
            ) {
              filterBar.className =
                'pb-service-list-service-filter filter-container fixed-service-filters';
              filterBar.style.top = header.clientHeight + 18 + 'px';
            }
          } else if (
            +servicePageContent.getBoundingClientRect().bottom.toFixed(0) <=
            +filterBar.getBoundingClientRect().bottom.toFixed(0)
          ) {
            if (
              filterBar.className !=
              'pb-service-list-service-filter filter-container absolute-service-filters'
            ) {
              filterBar.className =
                'pb-service-list-service-filter filter-container absolute-service-filters';
              filterBar.style.top = 'initial';
            }
          } else {
            if (filterBar.className != 'pb-service-list-service-filter filter-container') {
              filterBar.className = 'pb-service-list-service-filter filter-container';
              filterBar.style.top = 0;
            }
          }
        }
      }
      if (menu) {
        if (
          !(
            this.props.history.location.pathname.length > 4 &&
            !CommonService.isHome(this.props.history.location.pathname) &&
            this.props.history.location.pathname.indexOf('index.ht') < 0 &&
            this.props.history.location.pathname.indexOf('my-account') < 0
          )
        ) {
          if (
            (scroll > menu.clientHeight - 220 &&
              this.props.history.location.pathname.indexOf('my-account') < 0) ||
            (scroll > menu.clientHeight - 100 &&
              this.props.history.location.pathname.indexOf('my-account') >= 0)
          ) {
            if (!this.topStripClass) {
              this.topStripClass = 'header-box  payments-page-header';
              this.topHeader.className !=
              'nav-section home-nav-section common-top-strip header-box payments-page-header'
                ? (this.topHeader.className =
                    'nav-section home-nav-section common-top-strip header-box payments-page-header')
                : null;
              // this.setState({ scroll: true });
            }
            if (this.logoType != 2) {
              this.logoType = 2;
              this.setState({
                logoType: 2,
              });
            }
          } else {
            if (this.topStripClass) {
              this.topStripClass = '';
              this.topHeader.className != 'nav-section home-nav-section common-top-strip'
                ? (this.topHeader.className = 'nav-section home-nav-section common-top-strip')
                : null;
              // this.setState({ scroll: true });
            }
            if (this.logoType != 1) {
              this.logoType = 1;
              this.setState({
                logoType: 1,
              });
            }
          }
        } else if (this.props.history.location.pathname.indexOf('my-account') >= 0) {
          // if (scroll > 300) {
          //   this.topStripClass = 'header-box  payments-page-header';
          //   this.topHeader.className = 'nav-section home-nav-section common-top-strip header-box payments-page-header';
          // } else {
          //   this.topStripClass = '';
          //   this.topHeader.className = 'nav-section home-nav-section common-top-strip';
          // }
        } else if (
          this.props.history.location.pathname.length <= 4 ||
          CommonService.isHome(this.props.history.location.pathname) ||
          this.props.history.location.pathname.indexOf('index.ht') > -1
        ) {
          if (scroll > 300) {
            this.topStripClass = 'header-box  payments-page-header';
            this.topHeader.className =
              'nav-section home-nav-section common-top-strip header-box payments-page-header';
          } else {
            this.topStripClass = '';
            this.topHeader.className = 'nav-section home-nav-section common-top-strip';
          }
        }
      }
    });
  };

  componentWillUpdate() {
    var menuSearch = window.document.querySelector('.common-new-search-box');
    if (menuSearch) {
      let scroll = window.pageYOffset;
      if (scroll > 60) {
        menuSearch.className = 'common-new-search-box hide-searchbox';
        this.props.pbServiceList.openNewSearch
          ? this.props.actions.openCloseNewSearch(false)
          : null;
      } else {
        menuSearch.className = 'common-new-search-box';
      }
    }
    if (
      this.props.history.location.pathname.length > 4 &&
      !CommonService.isHome(this.props.history.location.pathname) &&
      this.props.history.location.pathname.indexOf('index.ht') < 0 &&
      this.props.history.location.pathname.indexOf('my-account') < 0 &&
      this.topHeader
    ) {
      this.topStripClass = 'header-box';
      this.topHeader.className = 'nav-section home-nav-section common-top-strip header-box';
      if (this.logoType != 2) {
        this.logoType = 2;
        this.setState({
          logoType: 2,
        });
      }
      if (CommonService.isBusOrTrain()) {
        if (!this.showSearchBox) {
          this.showSearchBox = true;
          this.setState({
            showSearchBox: true,
          });
        }
        // this.topStripClass = 'header-box';
        // this.topHeader.className = 'nav-section home-nav-section common-top-strip header-box';
        this.pbSourceCity =
          this.pbSourceCity || (this.props.home.pbSourceCity && this.props.home.pbSourceCity.label);
        this.pbDestinationCity =
          this.pbDestinationCity ||
          (this.props.home.pbDestinationCity && this.props.home.pbDestinationCity.label);
        this.pbOnwardDate =
          this.pbOnwardDate ||
          (this.props.home.onwardPBDate &&
            DateService.getDayNameFromDate(this.props.home.onwardPBDate) +
              ', ' +
              DateService.getDateFromDate(this.props.home.onwardPBDate) +
              ' ' +
              DateService.getMonthNameFromDate(this.props.home.onwardPBDate));
        this.pbReturnDate =
          this.pbReturnDate ||
          (this.props.home.returnPBDate &&
            DateService.getDayNameFromDate(this.props.home.returnPBDate) +
              ', ' +
              DateService.getDateFromDate(this.props.home.returnPBDate) +
              ' ' +
              DateService.getMonthNameFromDate(this.props.home.returnPBDate));
      } else {
        if (
          !(
            this.props.history.location.pathname.indexOf('my-account') >= 0 ||
            this.props.history.location.pathname.indexOf('bus') >= 0 ||
            this.props.history.location.pathname.length <= 4 ||
            CommonService.isHome(this.props.history.location.pathname) ||
            this.props.history.location.pathname.indexOf('index.ht') > -1
          )
        ) {
          this.topStripClass = 'header-box  payments-page-header';
          this.topHeader.className =
            'nav-section home-nav-section common-top-strip header-box payments-page-header';
        }
        if (this.showSearchBox) {
          this.showSearchBox = false;
          this.setState({ showSearchBox: false });
        }
      }
    } else if (
      this.props.history.location.pathname.indexOf('my-account') >= 0 ||
      this.props.history.location.pathname.length <= 4 ||
      CommonService.isHome(this.props.history.location.pathname) ||
      this.props.history.location.pathname.indexOf('index.ht') > -1
    ) {
      setTimeout(() => {
        var menu = window.document.querySelector('.home-banner');
        let scroll = window.pageYOffset;
        if (menu) {
          if (
            (scroll > menu.clientHeight - 220 &&
              this.props.history.location.pathname.indexOf('my-account') < 0) ||
            (scroll > menu.clientHeight - 100 &&
              this.props.history.location.pathname.indexOf('my-account') >= 0)
          ) {
            this.topStripClass = 'header-box  payments-page-header';
            this.topHeader.className !=
            'nav-section home-nav-section common-top-strip header-box payments-page-header'
              ? (this.topHeader.className =
                  'nav-section home-nav-section common-top-strip header-box payments-page-header')
              : null;
            // this.setState({ scroll: true });
            if (this.logoType != 2) {
              this.logoType = 2;
              this.setState({
                logoType: 2,
              });
            }
          } else {
            this.topStripClass = '';
            this.topHeader.className != 'nav-section home-nav-section common-top-strip'
              ? (this.topHeader.className = 'nav-section home-nav-section common-top-strip')
              : null;
            // this.setState({ scroll: true });
            if (this.logoType != 1) {
              this.logoType = 1;
              this.setState({
                logoType: 1,
              });
            }
          }
        }
        if (this.showSearchBox) {
          this.showSearchBox = false;
          this.setState({ showSearchBox: false });
        }
      }, 150);
    } else {
    }
  }

  loadStartupData = () => {
    this.props.actions.getMetaData();
    this.props.actions.getUniqueCities();
    // this.props.actions
    //   .apiCall({
    //     url: AppData.BASE_URL + 'api/site_map',
    //     type: 'home',
    //   })
    //   .then(
    //     res => this.onSitemapFetch(res),
    //     err => this.onSitemapFetch(err),
    //   );

    this.props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/stage_details',
        type: 'home',
      })
      .then(
        (res) => this.onstageDetailsFetch(res),
        (err) => this.onstageDetailsFetch(err),
      );
  };

  onstageDetailsFetch = (result) => {
    if (result && result.data && result.data.body) {
      this.props.actions.setStagesData(result.data.body);
    }
  };

  onSitemapFetch = (result) => {
    if (result && result.data) {
      this.props.actions.setSiteMapData(result.data);
    }
  };

  newSearch = () => {
    this.setState({ newSearchKey: this.state.newSearch + 1 });
    this.pbSourceCity = this.props.home.pbSourceCity && this.props.home.pbSourceCity.label;
    this.pbDestinationCity =
      this.props.home.pbDestinationCity && this.props.home.pbDestinationCity.label;
    this.pbOnwardDate =
      this.props.home.onwardPBDate &&
      DateService.getDayNameFromDate(this.props.home.onwardPBDate) +
        ', ' +
        DateService.getDateFromDate(this.props.home.onwardPBDate) +
        ' ' +
        DateService.getMonthNameFromDate(this.props.home.onwardPBDate);
    this.pbReturnDate =
      this.props.home.returnPBDate &&
      DateService.getDayNameFromDate(this.props.home.returnPBDate) +
        ', ' +
        DateService.getDateFromDate(this.props.home.returnPBDate) +
        ' ' +
        DateService.getMonthNameFromDate(this.props.home.returnPBDate);
    CommonService.newSearchFunction();
  };

  renderMainLoader = () => {
    return (
      <div className="main-app-loader content-container">
        <span>Loading..</span>
      </div>
    );
  };

  swapCities = () => {
    let source = CommonService.copyObject(this.props.home.pbSourceCity);
    let dest = CommonService.copyObject(this.props.home.pbDestinationCity);
    this.props.actions.pbSetSourceCity(dest);
    this.props.actions.pbSetDestinationCity(source);
  };

  onLogoClicked = () => {
    if (
      this.props.history.location.pathname.length == 1 ||
      this.props.history.location.pathname.indexOf('index.ht') >= 0
    ) {
      window.location.reload();
    }
  };

  resetPassword = () => {
    let errorCount = 0;
    if (!this.state.resetPassword) {
      this.setState({
        resetPasswordError: 'VALIDATIONS.VALID_PASSWORD',
      });
      errorCount++;
    } else {
      if (this.state.resetPassword.length < 8) {
        this.setState({
          resetPasswordError: 'VALIDATIONS.VALID_PASSWORD_LENGTH',
        });
      }
    }
    if (this.state.resetPassword != this.state.resetConfirmPassword) {
      this.setState({
        resetConfirmPasswordError: 'VALIDATIONS.VALID_CONFIRM_PASSWORD',
      });
    }
    if (errorCount > 0) {
      return;
    }
    let data = {
      user: {
        password: this.state.resetPassword,
        password_confirmation: this.state.resetConfirmPassword,
        reset_password_token: CommonService.getParameterByName('reset_password_token'),
      },
    };
    this.props.actions
      .resetNewPassword({
        url: ApiUrls.resetNewPassword(CommonService.getParameterByName('reset_password_token')),
        data: data,
      })
      .then(
        (res) => {
          if (res.data && res.data.status == 200) {
            this.setState({
              showSuccessModel: true,
              showSuccessStatus: true,
              showSuccessBody: 'Tu contraseña ha sido actualizada.',
              showResetPasswordModal: false,
            });
          } else if (res.data) {
            this.setState({
              showSuccessModel: true,
              showSuccessStatus: false,
              showSuccessBody: res.data.error,
            });
          }
        },
        (err) => {
          console.log(err);
        },
      );
  };

  changeSourceCityAndResetDest = (val) => {
    this.props.actions.pbSetSourceCity(val);

    if (this.props.home.pbDestinationCity && val.value == this.props.home.pbDestinationCity.value) {
      this.props.actions.pbSetDestinationCity(null);
    }
  };

  handleSideMenu = (val) => {
    this.setState({ showMenu: val });
    document.getElementsByTagName('body')[0].style.overflow = `${val ? 'hidden' : 'auto'}`;
  };

  render() {
    const { t, i18n } = this.props;
    return (
      <div className="home-app">
        <TopStrip
          t={t}
          i18n={i18n}
          onMenuIconClick={() => this.handleSideMenu(true)}
          // classes={this.topStripClass}s
          logoType={this.state.logoType}
          history={this.props.history}
          metaData={this.props.home.metaData}
          onLogoClicked={this.onLogoClicked}
          // key={(this.props.home.pbSourceCity || {}).value + (this.props.home.pbDestinationCity || {}).value}
          newSearch={
            this.state.showSearchBox && (
              <NewSearchBox
                cities={
                  CommonService.isTrain()
                    ? this.props.home.uniqueCitiesTrain
                    : this.props.home.uniqueCities
                }
                openNewSearch={this.props.pbServiceList.openNewSearch}
                pbSourceCity={this.props.home.pbSourceCity}
                sourceCityOnChange={this.changeSourceCityAndResetDest}
                // sourceCityOnChange={this.props.actions.pbSetSourceCity}
                pbDestinationCity={this.props.home.pbDestinationCity}
                destinationCityOnChange={this.props.actions.pbSetDestinationCity}
                onwardPBDate={this.props.home.onwardPBDate}
                onwardDateChange={this.props.actions.setOnwardPbDate}
                returnPBDate={this.props.home.returnPBDate}
                returnDateChange={this.props.actions.setReturnPbDate}
                swapCities={this.swapCities}
                newSearch={this.newSearch}
                t={t}
                key={this.state.newSearchKey}
                isMot={this.props.home.is_mot}
              />
            )
          }
        >
          {/* {this.showSearchBox ? this.renderSelectedSearchBox() : null} */}
        </TopStrip>

        {!this.props.home ? this.renderMainLoader() : this.props.children}
        <KuposFooter
          metaData={this.props.home.metaData}
          t={t}
          history={this.props.history}
          actions={this.props.actions}
        />
        <KuposModalWithButtons
          showModal={this.state.showResetPasswordModal}
          showButton1={false}
          size="md"
        >
          <div className="reset-modal-inp">
            <div
              className="close-button pointer"
              onClick={() => {
                this.setState({ showResetPasswordModal: false });
                this.props.history.push('/');
              }}
            >
              <SvgHome name="close" />
            </div>
            <div className="inp">
              <div className="inp-label bold-text font10">Contraseña</div>
              <KuposInput
                type="password"
                className="kupos-border"
                placeholder="Ingrese Contraseña"
                onChange={(text) =>
                  this.setState({ resetPassword: text, resetPasswordError: null })
                }
                onBlur={() => {}}
                value={this.state.resetPassword}
                error={this.state.resetPasswordError ? true : false}
                errorMessage={this.state.resetPasswordError}
              />
            </div>
            <div className="inp">
              <div className="inp-label bold-text font10">Confirme Contraseña</div>
              <KuposInput
                type="password"
                className="kupos-border"
                placeholder="Confirme Contraseña"
                onChange={(text) =>
                  this.setState({ resetConfirmPassword: text, resetConfirmPasswordError: null })
                }
                onBlur={() => {}}
                value={this.state.resetConfirmPassword}
                error={this.state.resetConfirmPasswordError ? true : false}
                errorMessage={this.state.resetConfirmPasswordError}
              />
            </div>
            <div className=" font12">
              <button
                disabled={this.props.home.resetNewPasswordPending}
                className="kupos-button"
                onClick={this.resetPassword}
              >
                {this.props.home.resetNewPasswordPending ? (
                  <div className="loader-cricle"></div>
                ) : (
                  <span>{this.props.t('Cambia la contraseña')}</span>
                )}
              </button>
            </div>
          </div>
        </KuposModalWithButtons>
        <KuposErrorSuccessModal
          showModal={this.state.showSuccessModel}
          success={this.state.showSuccessStatus}
          bodyText={this.state.showSuccessBody}
          onButtonClick={() =>
            this.setState({
              showSuccessModel: false,
              showSuccessModel: null,
              showSuccessBody: null,
            })
          }
        />
        <SideMenu
          history={this.props.history}
          showMenu={this.state.showMenu}
          t={this.props.t}
          closeMenu={() => this.handleSideMenu(false)}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
    pbServiceList: state.pbServiceList,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...serviceActions, ...commonActoins }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(App));



// WEBPACK FOOTER //
// ./src/features/home/App.js